import { createRoute } from '@tanstack/react-router'
import rootRoute from '../rootRoute'
import AdminTabs from './AdminTabs'
import AdminEntitiesCRUD from '@/components/admin/AdminEntitiesCRUD'
import { adminRouteLoader } from '@/lib/auth'
import { spacing } from '@/components/ui'

function AdminEntitiesView() {
  return (
    <div
      style={{
        maxWidth: 'var(--container-max)',
        margin: '0 auto',
        padding: 'var(--space-8) var(--gutter) var(--space-20)',
      }}
    >
      <AdminTabs />
      <div className="oumma-overline" style={{ marginBottom: spacing.sm }}>
        Espace admin
      </div>
      <h1 style={{ fontSize: 'var(--text-h1)', margin: '0 0 28px' }}>
        Entités
      </h1>
      <AdminEntitiesCRUD />
    </div>
  )
}

export const adminEntitiesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/admin/entities',
  loader: adminRouteLoader,
}).lazy(() => import('./AdminEntitiesView.lazy').then((m) => m.Route))

export default AdminEntitiesView
